import Notification from "./components/Notification";
import LoginPage from "./layouts/LoginPage";
import UserPage from "./layouts/UserPage";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

function App() {
  return (
    <div>
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/*" element={<UserPage />} />
      </Routes>
    </Router>
    <Notification /> 
    </div>
  );
}

export default App;
